const getPathname = state => {
  const { location } = state.router;
  if (location) {
    return location.pathname;
  }
  return null;
};

export default getPathname;
